<mat-card appearance="outlined">
  <div class="app-dialog">
    <h1 class="app-dialog-title" mat-dialog-title>
      {{ title }}
    </h1>

    <mat-dialog-content>
      <p class="app-dialog-text">{{ message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      @switch (true) { @case (data.type === DialogType.CONFIRM) {
      <button
        matButton="elevated"
        color="warn"
        (click)="onConfirm()"
        i18n="@@buttonYes"
      >
        Yes
      </button>
      <button matButton (click)="onDismiss()" i18n="@@buttonNo">No</button>
      } @case (data.type === DialogType.MESSAGE) {
      <button matButton (click)="onDismiss()" i18n="@@buttonOK">OK</button>
      } }
    </mat-dialog-actions>
  </div>
</mat-card>
